import { render, staticRenderFns } from "./ScrollToDiv.vue?vue&type=template&id=fb5b8eb2&"
import script from "./ScrollToDiv.vue?vue&type=script&lang=js&"
export * from "./ScrollToDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb5b8eb2')) {
      api.createRecord('fb5b8eb2', component.options)
    } else {
      api.reload('fb5b8eb2', component.options)
    }
    module.hot.accept("./ScrollToDiv.vue?vue&type=template&id=fb5b8eb2&", function () {
      api.rerender('fb5b8eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jMOguKsNkmF9/JS/comp/ScrollToDiv.vue"
export default component.exports